._motion-panel_1nlc3_1 {
  --panel-content-max-height: calc(var(--comp-Panel-Frame-Height, 525) * 1px);
  --panel-content-min-height: 300px;
  --panel-content-height: clamp(var(--panel-content-min-height), 100vh - 3rem - var(--header-height, 50px), var(--panel-content-max-height));
  --section-header-height: 43px;
  --customize-button-height: 50px;
  --customize-max-height: var(--panel-content-height);
  --list-max-height: calc(var(--panel-content-height) - var(--apply-button-height, 0px) - var(--customize-button-height) - var(--section-padding-top, 0px) - var(--section-header-height) * var(--section-headers-count, 3));
  min-height: calc(var(--panel-content-height) - var(--section-header-height)); }
  ._motion-panel_1nlc3_1 .control-collapse-label {
    border-bottom: 1px solid #ececec; }
    .classic-facelift-skin ._motion-panel_1nlc3_1 .control-collapse-label {
      border-bottom-color: #e0e0e0; }
    .responsive-skin ._motion-panel_1nlc3_1 .control-collapse-label {
      border-bottom-color: #f3f3f3; }

._section-inner_1nlc3_17 {
  height: 100%;
  position: relative; }

._animation-list_1nlc3_21 {
  padding-top: var(--section-padding-top, 0px); }
  ._animation-list_1nlc3_21 .custom-scroll .inner-container {
    max-height: var(--list-max-height);
    padding-bottom: var(--customize-button-height); }
  ._animation-list_1nlc3_21 .composite-thumbnails {
    padding-top: 12px; }
  ._animation-list_1nlc3_21 .is-disabled .thumb-none-symbol > .line {
    stroke: #bcbcbc !important; }
    .classic-facelift-skin ._animation-list_1nlc3_21 .is-disabled .thumb-none-symbol > .line {
      stroke: #bcbcbc !important; }
  ._animation-list_1nlc3_21 .is-disabled [data-ds-class="illus-clr-2"] {
    fill: #bcbcbc !important; }
    .classic-facelift-skin ._animation-list_1nlc3_21 .is-disabled [data-ds-class="illus-clr-2"] {
      fill: #bcbcbc !important; }
    .responsive-skin ._animation-list_1nlc3_21 .is-disabled [data-ds-class="illus-clr-2"],
    .responsive-skin :hover ._animation-list_1nlc3_21 .is-disabled [data-ds-class="illus-clr-2"] {
      fill: #bebebe !important; }
  ._animation-list_1nlc3_21 .is-disabled .label {
    color: #939393 !important; }
    .classic-facelift-skin ._animation-list_1nlc3_21 .is-disabled .label {
      color: #898989 !important; }
  ._animation-list_1nlc3_21 .is-disabled .illustration-background {
    background-color: #f0f0f0 !important; }
    .classic-facelift-skin ._animation-list_1nlc3_21 .is-disabled .illustration-background {
      background-color: #f0f0f0 !important; }
  ._animation-list_1nlc3_21 .is-disabled .selected .illustration-background {
    box-shadow: inset 0 0 0 2px #e2e2e2 !important; }
    .classic-facelift-skin ._animation-list_1nlc3_21 .is-disabled .selected .illustration-background {
      box-shadow: inset 0 0 0 2px #e0e0e0 !important; }

._animation-thumb_1nlc3_52 {
  flex-shrink: 0;
  display: grid;
  grid-template: 'content' 1fr / 1fr; }
  ._animation-thumb_1nlc3_52 path {
    transition: fill 0.3s ease-in-out; }
  ._animation-thumb_1nlc3_52 > * {
    grid-area: content;
    width: 100%;
    height: 100%;
    transition: opacity 0.2s ease-in-out; }
  ._animation-thumb_1nlc3_52[data-selected]:hover, ._animation-thumb_1nlc3_52[data-keep] {
    cursor: pointer; }
    ._animation-thumb_1nlc3_52[data-selected]:hover ._animation-thumb-idle_1nlc3_65, ._animation-thumb_1nlc3_52[data-keep] ._animation-thumb-idle_1nlc3_65 {
      opacity: 0; }
    ._animation-thumb_1nlc3_52[data-selected]:hover ._animation-thumb-hover_1nlc3_67, ._animation-thumb_1nlc3_52[data-keep] ._animation-thumb-hover_1nlc3_67 {
      opacity: 1; }

._animation-thumb-hover_1nlc3_67 {
  color: #fff;
  opacity: 0;
  display: grid;
  grid-template: 'content' 1fr / 1fr;
  place-items: center center; }
  ._animation-thumb-hover_1nlc3_67 > * {
    grid-area: content; }
  .classic-facelift-skin ._animation-thumb-hover_1nlc3_67 {
    color: #fff; }
  .responsive-skin ._animation-thumb-hover_1nlc3_67 {
    color: #f4f5f8; }

.illustration-background {
  transition: background-color 0.3s ease-in-out; }

._animation-customize_1nlc3_86 {
  padding-bottom: 12px; }
  ._animation-customize_1nlc3_86 .custom-scroll .inner-container {
    max-height: var(--customize-max-height); }

._animation-customize-preview_1nlc3_91 {
  display: flex;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: #ececec 1px solid; }
  .classic-facelift-skin ._animation-customize-preview_1nlc3_91 {
    border-bottom-color: #e0e0e0; }
  .responsive-skin ._animation-customize-preview_1nlc3_91 {
    border-bottom-color: #f3f3f3; }

._animation-customize-preview-progress_1nlc3_101 {
  width: 26px;
  height: 26px;
  color: #3899ec;
  display: grid;
  grid-template: 'content' 1fr / 1fr;
  place-items: center center;
  cursor: pointer; }
  ._animation-customize-preview-progress_1nlc3_101 > * {
    grid-area: content; }
  .classic-facelift-skin ._animation-customize-preview-progress_1nlc3_101 {
    color: #116dff; }
  .responsive-skin ._animation-customize-preview-progress_1nlc3_101 {
    color: #116dff; }

._customize-button_1nlc3_116 {
  position: absolute;
  bottom: 0;
  padding: 20px 0;
  background: linear-gradient(0deg, #fff 15px, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  width: 100%;
  display: flex;
  justify-content: center; }
  .classic-facelift-skin ._customize-button_1nlc3_116 {
    background: linear-gradient(0deg, #fff 15px, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0)); }
  .responsive-skin ._customize-button_1nlc3_116 {
    background: linear-gradient(0deg, #f4f5f8 15px, rgba(244, 245, 248, 0.5) 60%, rgba(244, 245, 248, 0)); }

._direction-drop-down-item_1nlc3_129 {
  rotate: calc(var(--dropdown-direction-item-rotate, 0) * 1deg);
  scale: var(--dropdown-direction-item-flip, 1) 1;
  height: 24px;
  width: 24px;
  color: black; }

._notification-banner-wrapper_1nlc3_136 {
  padding: 6px 23px 4px 24px;
  border-radius: 4px; }
  ._notification-banner-wrapper_1nlc3_136 .notification-banner-contents .notification-banner-link {
    margin-left: 0; }
    ._notification-banner-wrapper_1nlc3_136 .notification-banner-contents .notification-banner-link::before {
      content: " "; }

._apply-from-desktop-button_1nlc3_144 {
  padding: 10px 22px;
  display: flex;
  justify-content: space-between; }
  ._apply-from-desktop-button_1nlc3_144 ._apply-from-desktop-info-icon_1nlc3_148 {
    opacity: 0; }
  ._apply-from-desktop-button_1nlc3_144:hover ._apply-from-desktop-info-icon_1nlc3_148 {
    opacity: 1; }
